import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  EventListRoad,
  type EventListRoadType,
} from '@/domains/traffic-monitoring/constants/smartCity.constant';
import { cn } from '@/lib/utils';
import { useColorStore } from '@/store/colorStore';

interface CardEventSmartCityProps {
  title: string;
  address: string;
  dateTime: string;
  onclick?: () => void;
  // Optional severity badge. Omit to render the card without it.
  eventListRoadType?: EventListRoadType;
}

const CardEventSmartCity = ({
  eventListRoadType,
  title,
  address,
  onclick,
  dateTime,
}: CardEventSmartCityProps) => {
  const { t } = useTranslation();
  const { NEWCOLOR } = useColorStore();
  const status = eventListRoadType ? EventListRoad[eventListRoadType] : null;

  return (
    <button
      type="button"
      onClick={onclick}
      className={cn(
        'w-full rounded-[12px] p-3 hover:border-bg-grey-500 dark:hover:border-bg-grey-400 items-start text-start dark:bg-[#F3F6FE]/10  border shadow-[0_4px_4px_0_rgba(0,0,0,0.16)] flex flex-col cursor-pointer'
      )}
    >
      <div className="inline-flex w-full gap-3 justify-between items-center">
        <span className="title1bold">{t(title)}</span>
        {status && (
          <span
            className="title2 px-3 text-white py-1 uppercase rounded-full"
            style={{
              backgroundColor: NEWCOLOR[status.bg],
            }}
          >
            {t(`cmn>master>${status.label}`)}
          </span>
        )}
      </div>
      <div className="flex flex-col">
        <span className="title2">{address}</span>
        <span className="title2 text-text-grey">{dateTime}</span>
      </div>
    </button>
  );
};

export default CardEventSmartCity;
